import Helper from './Helper';

class Menu {
  constructor() {
    // console.log('constructor');
    this.hamburger = document.querySelector('.header__hamburger');
    this.bindEvents();

		// Move Header Right Menu and Search Bar into the Toggleable Menu if screen is lower than 768px
    this.moveElementResponsively(
      document.querySelector('.nav-and-search'),
      document.querySelector('.header__middle'),
      window.matchMedia('(min-width: 768px)'),
      window
		);

		this.removeClassResponsively('offcanvas--in', window.matchMedia('(min-width: 768px)'), window);
		this.removeClassResponsively('animate--in', window.matchMedia('(min-width: 768px)'), window);
  }

  bindEvents() {
    // console.log('bindEvents function');
    this.hamburger.addEventListener('click', e => {
      this.toggleHamburger(this.hamburger);
    });
  }

  toggleHamburger(burger) {
		// console.log('toggle Hamburger');
		let toggleContainer = burger.getAttribute('data-toggles-nav');
    let menu = document.querySelector(`.${toggleContainer}`);

    if (Helper.hasClass(burger, 'animate--in')) {
      Helper.removeClass(document.querySelector('body'), 'menu-open');
      Helper.removeClass(menu, 'offcanvas--in');
      Helper.addClass(menu, 'offcanvas--out');
      Helper.removeClass(burger, 'animate--in');
      Helper.addClass(burger, 'animate--out');
    } else {
      Helper.addClass(document.querySelector('body'), 'menu-open');
      Helper.addClass(menu, 'offcanvas--in');
      Helper.removeClass(menu, 'offcanvas--out');
      Helper.addClass(burger, 'animate--in');
      Helper.removeClass(burger, 'animate--out');
    }
  }

  moveElementResponsively(movableElement, targetContainer, breakpoint, window) {
    let originalParent = movableElement.parentElement;

    function move() {
      if (breakpoint.matches) {
        // If media query matches
        if (targetContainer.contains(movableElement)) {
          targetContainer.removeChild(movableElement);
          originalParent.appendChild(movableElement);
        }
      } else {
        if (originalParent.contains(movableElement)) {
          originalParent.removeChild(movableElement);
          targetContainer.appendChild(movableElement);
        }
      }
    }

    move();
    window.addEventListener('resize', () => {
      move();
    });
	}

  removeClassResponsively(removableClass, breakpoint, window) {
    function remove() {
			let el = document.querySelector(`.${removableClass}`);

      if (breakpoint.matches) {
				// If media query matches
				if(el){
					el.classList.remove(removableClass);
				}
      }
    }

    remove();
    window.addEventListener('resize', () => {
      remove();
    });
  }

  killMenu() {
    let burger = this.hamburger;

    Helper.removeClass(burger, 'animate--in');
    Helper.addClass(burger, 'animate--out');

    Helper.removeClass(document.querySelector('body'), 'menu-open');
  }
}

export default Menu;
